import BaseProxy from './base-proxy';
/**
 * Class LicenseProxy
 */
class LicenseProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/invoice-robotics-api/api', parameters);
    this.licensesEndpoint = '/licenses-api/api';
  }

  getSubscriptionsMonitor() {
    return this.submit('get', `${this.licensesEndpoint}/get-subscriptions-monitor`);
  }

  /**
   * @returns {Promise}
   */
  getSubscriptions() {
    /*
    *  {
      "id": 7,
      "company_id": 5,
      "plan_id": {
        "id": 1,
        "name": "IR_FREE",
        "price": "0",
        "capacity": null,
        "term": null,
        "service": "IR"
      },
      "capacity": null,
      "start": "2021-12-22",
      "end": null,
      "total": null,
      "service": "IR"
    }
    * */
    return this.submit('get', `${this.endpoint}/get-subscriptions-ir`);
  }
}

export default LicenseProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/license-proxy.js